import { useCallback, useEffect } from 'react';
import { Grid } from '@mui/material';
import CustomCircularProgress from 'components/common/CustomCircularProgress';
import { useNavigate, useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import { updateCase } from 'services/case/updateCase';
import { closeModal, openModal } from 'reducers/modalReducer';

const styles = {
  spinnerContainer: {
    backgroundColor: 'white',
    position: 'absolute',
    transform: 'translate(-50%, -50%)',
    left: '48%',
    top: '45%',
  },
};

type Props = {
  location: string;
};

export const CaseUpdate = ({ location }: Props) => {
  const { id, caseId } = useParams<{ id: string; caseId: string }>();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const callUpdateCase = useCallback(async () => {
    if (!caseId) return;
    try {
      await updateCase(caseId);
      navigate(`/${location}/${id}/case/${caseId}`);
    } catch (error) {
      dispatch(
        openModal({
          modalType: 'JBErrorModalWrapper',
          modalProps: {
            httpError: error,
            okHandler: () => {
              dispatch(closeModal());
            },
            technicalInfo: {
              title: 'Error when trying to update case',
              userErrorMessage: `An error occurred when trying to update case. Please try again later.`,
            },
          },
        }),
      );
    }
  }, [dispatch, caseId, id, location, navigate]);

  useEffect(() => {
    if (id && caseId) {
      // noinspection JSIgnoredPromiseFromCall
      callUpdateCase();
    }
  }, [callUpdateCase, caseId, id]);

  return (
    <Grid
      data-testid="case-update"
      container
      justifyContent={'center'}
      alignContent={'center'}
      sx={styles.spinnerContainer}
    >
      <Grid item>
        <CustomCircularProgress size={70} />
      </Grid>
    </Grid>
  );
};
